import { inject, Injectable } from '@angular/core';
import {
  BasicDialogService,
  DialogPresets,
} from '@principle-theorem/ng-shared';
import {
  type IPractice,
  isPractice,
} from '@principle-theorem/principle-core/interfaces';
import { type WithRef, isWithRef, snapshot } from '@principle-theorem/shared';
import { ManagementResource } from '../models/management-resource';
import {
  type IManagementTool,
  type IToolRunContext,
} from '../models/management-tool';
import {
  type IBridgeDiagnosticsDialogData,
  BridgeDiagnosticsDialogComponent,
} from '../bridge-diagnostics-dialog/bridge-diagnostics-dialog.component';

function isPracticeWithRef(value: unknown): value is WithRef<IPractice> {
  return isPractice(value) && isWithRef<IPractice>(value);
}

@Injectable({ providedIn: 'root' })
export class BridgeDiagnosticsTool implements IManagementTool {
  private _dialog = inject(BasicDialogService);

  readonly name = 'bridge-diagnostics';
  readonly label = 'Bridge Diagnostics';
  readonly icon = 'cable';
  readonly description =
    'Diagnostic status and config conflict checks for bridge devices';
  readonly resource = ManagementResource.Practice;

  async run(context: IToolRunContext): Promise<void> {
    if (!context.resource) {
      return;
    }
    const value = await snapshot(context.resource.value$);
    if (!value || !isPracticeWithRef(value)) {
      return;
    }
    const data: IBridgeDiagnosticsDialogData = { practice: value };
    this._dialog.open(
      BridgeDiagnosticsDialogComponent,
      DialogPresets.almostFullscreen({ data, height: '90vh' })
    );
  }
}
